export default __webpack_public_path__ + "static/media/FriedRavioli.c0b27743.jpg";